import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex gap-1" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["disabled", "data-test-id"]

import { ref } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'DocumentLink',
  props: {
    linkText: {},
    enabled: { type: Boolean },
    enabledIcon: {},
    disabledIcon: {},
    dataTestId: {}
  },
  emits: ['linkClicked'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const icon = ref(props.enabled ? props.enabledIcon : props.disabledIcon);
const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      class: "w-[0.75rem] h-[0.882rem] mt-1",
      src: icon.value,
      alt: "Document icon"
    }, null, 8, _hoisted_2),
    _createElementVNode("button", {
      class: "link text-m",
      disabled: !_ctx.enabled,
      "data-test-id": _ctx.dataTestId,
      onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('linkClicked')))
    }, _toDisplayString(_ctx.linkText), 9, _hoisted_3)
  ]))
}
}

})